<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus"  title="选择研发任务" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="rd_process,rd_task"
        placeholder="输入研发阶段或研发任务名称"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.rd_task}}</p>
          <p class="list-item-muted">{{item.rd_process}} {{item.rs_product_type}}</p>
        </div>
        <div class="weui-cell__ft">{{item.rd_rscode}}</div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "研发任务"
    },
    value: String,
    extraParams: Object,
    condition:Array
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/plm/research/list",
      defaultCondition: this.condition
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.rd_task);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>